"use strict";

exports.__esModule = true;
exports.uiSwitch = uiSwitch;
var _react = _interopRequireWildcard(require("react"));
var _UiDesignContext = require("./UiDesignContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * A component that renders `Legacy` or `Modern` depending on the nearest
 * UiDesignProvider. The seam for every component the modern UI rewrote:
 * the legacy file stays as it was on master, the rewrite sits beside it as
 * `<Name>.modern.js`, and the directory exports this switch under the
 * original name. Removing the experiment means deleting one side and
 * replacing the switch with the survivor.
 */
function uiSwitch(Legacy, Modern, name) {
  var Switch = /*#__PURE__*/_react["default"].forwardRef(function UiSwitch(props, ref) {
    var _useContext = (0, _react.useContext)(_UiDesignContext.UiDesignContext),
      modern = _useContext.modern;
    var Component = modern ? Modern : Legacy;
    return ref ? /*#__PURE__*/_react["default"].createElement(Component, _extends({
      ref: ref
    }, props)) : /*#__PURE__*/_react["default"].createElement(Component, props);
  });
  Switch.displayName = "UiSwitch(" + (name || Modern.displayName || Modern.name || "Component") + ")";
  Switch.Legacy = Legacy;
  Switch.Modern = Modern;
  return Switch;
}